// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,

  user: 'UNIVERSAL_APP_ID',
  pass: 'b^BJCYCA;wA2w[Y#',
  idApplication: 94,
  pipeDecimalFormat: '1.2-2',
  pipePointFormat: '1.0-0',
  pipeNoDecimalsFormat: '1.0-0',
  strMilesCurrency: 'M',
  defaultCurrencySlider: { 'iso': 'USD', 'displayName': 'US' },
  idSK: 'IVozZGcvRi1HcGAoXzh4JEIleyRuVXlZYXZycmQjJDU=',
  languageEnroll: 'en-US',
  timeZoneEnroll: 'Pacific Standard Time',
  urlLogosMR: 'https://images.allegraplatform.com/img/visa_rewards/Backoffice/',

  configChannel: {
    94: {
      universalUrlBase: 'https://universalws.gbl.imagineas.one/v1/getallpropertiesbyapplicationidVSV2',
      brand: 'milesv2', defaultBrandClass: 'miles-v2', homeType: 3, typeWalkthrough: 2, registerType: 3, isM4M: false, validateBin: false, lpBrandName: 'FC', backgroundBinCC: false,
      appName: 'Miles',
      assets: 'milesv2',
      haveVideoSplash: false, // Default is true
      whatIs: null,
      showInitIconIsMiles: false,
      canEditEmail: false,
      canShowEmail: true,
      speciali18n: true,
      typeBuyMiles: 2,
      minDefaultValueBuyMiles: 1, // Valor minimo de compra de millas en dolares
      isMultiTenant: true, // Si es true Muestro el logo - Si no esta o es falso oculto el logo
      // Symbolo prefijo de puntos a mostrar en detallle de transacciones ('': Coloca una M especial de puntos, 'points': El texto debe ser un key de traducciones y se coloca como prefijo al valor de los puntos)
      pointsTransactionCurrency: '',
      nameCardAplication: 'myRewardsDigitalCard',
      useJwtToken: false,
      useJwtTokenServices: {
        useJwtTokenUniversal: true,
        useJwtTokenAuth: true,
        useJwtTokenCreditCard: true,
        useJwtTokenUnique: true,
        useJwtTokenPurchase: false,
        useJwtTokenCrytmi: false,
        useJwtTokenTransactionProxy: true
      },
      UNIVERSAL_GET_JWTTOKEN_URL: 'https://universalws.gbl.imagineas.one/v1/getJWTTokenV2',
      UNIVERSAL_GET_JWTTOKEN_URL_COUNTRY: 'https://universalws.gbl.imagineas.one/v1/getJWTTokenV2',
      //UNIVERSAL_GET_JWTTOKEN_URL: 'https://universalws.cryptmi.com/v1/getJWTTokenV2',
      UNIVERSAL_GET_JWTTOKEN_UN: 'ZnJvbnRBdXRoRW5kQXBwQWRtaW4=',
      UNIVERSAL_GET_JWTTOKEN_PW: 'ZnJvbnRBdXRoRW5kQXBwQWRtaW4yMDE5KiM=',
      CONFIG_USER_GET_JWTTOKEN_URL: 'https://universalws.gbl.imagineas.one/v1/getCountryV2',
      // timeZoneDefault: 'QW1lcmljYS9Cb2dvdGE=',//Bogota
      timeZoneDefault: 'QXNpYS9EdWJhaQ==',//Dubai
      languajeTimeDefault: 'ZW4tVVM=',
      reqPass: 'HRzDb**imAeDT%%wwGc#Uq',
      resPass: 'nNk9rrBx%n$GgKlfCfNYke',
      chatBar: {
        showButtonMyWallet: true,
        showButtonTravel: true
      },
      pointsUser: {
        showPointsUser: true,
        assingValueDummy: false,
        valueDummy: 0
      },
      onepocketConfig: {
        classCard: 'card-novae',
        imageBackgroundCard: 'assets/img/card-bank.svg'
      },
      configLanguaje: {
        isMultiLang: true,
        useLanguagePhone: true,
        defaultLang: (isMultiLang) => {
          if (!isMultiLang) {
            return 'en';
          }
        }
      },
      flagPinNewUserWithEmail: false,
      flagValidateChangePws: false,
      canRewardOverReward: true
    }
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
